import React, { useMemo } from 'react';

import { useDataType } from '../../../common/hooks/use-data-type';
import { DATA_TYPE } from '../../../common/config/data-type';
import { composeGetTranslation } from 'common/react/utils/translations';
import { ToggleInput } from 'common/react/components/ToggleInput';
import { useSelector } from 'react-redux';
import { careerAndSeasonStatsBenchmarkingSelector } from 'store/modules/statspro/career-and-season-stats/selectors/benchmarking-selector';
import { careerAndSeasonStatsDataTypeSelector } from 'store/modules/statspro/career-and-season-stats/selectors/data-type-selector';
import { careerAndSeasonStatsActions } from 'common/store/modules/statspro/career-and-season-stats';

export const dataTypeOptions = [
    {
        label: composeGetTranslation('label.statsLeaders.dataType.')(
            DATA_TYPE.TOTALS
        ),
        value: DATA_TYPE.TOTALS
    },
    {
        label: composeGetTranslation('label.statsLeaders.dataType.')(
            DATA_TYPE.AVERAGES
        ),
        value: DATA_TYPE.AVERAGES
    }
];

export const DataTypeToggle = () => {
    const benchmarking = useSelector(careerAndSeasonStatsBenchmarkingSelector);
    const initialDataType = useSelector(careerAndSeasonStatsDataTypeSelector);

    const { dataType, updateDataType } = useDataType({
        initialDataType,
        onUpdateActionCreator: careerAndSeasonStatsActions.setDataType,
        isBenchmarkingActive: benchmarking.isActive
    });

    const options = useMemo(() => {
        return dataTypeOptions.map((option) => {
            // If we are using non-benchmarked data, disabled the average toggle.
            if (option.value === DATA_TYPE.AVERAGES) {
                return {
                    ...option,
                    disabled: dataType.isUsingNonBenchmarkedData
                };
            }

            return option;
        });
    });

    return (
        <ToggleInput
            id="careers-and-season-stats-data-type-toggle"
            value={
                dataType.type.toLowerCase().includes(DATA_TYPE.TOTALS)
                    ? DATA_TYPE.TOTALS
                    : DATA_TYPE.AVERAGES
            }
            onChange={updateDataType}
            options={options}
        />
    );
};

export default DataTypeToggle;
